import { render, staticRenderFns } from "./scancode.vue?vue&type=template&id=48c28dec&scoped=true&"
import script from "./scancode.vue?vue&type=script&lang=js&"
export * from "./scancode.vue?vue&type=script&lang=js&"
import style0 from "./scancode.vue?vue&type=style&index=0&id=48c28dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c28dec",
  null
  
)

export default component.exports